"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_ERROR_CODES = void 0;
exports.AUTH_ERROR_CODES = [
    'EMAIL_NOT_VERIFIED',
    'INVALID_CREDENTIALS',
    'ACCOUNT_LOCKED',
    'LINK_REQUIRED',
    'TOKEN_INVALID',
    'TOKEN_EXPIRED',
    'MFA_REQUIRED',
    'MFA_INVALID_CODE',
    'MFA_ALREADY_ENABLED',
    'MFA_NOT_ENABLED',
];
